/**
 * _calculators.js — the browser's formula for each calculator, by URL slug.
 *
 * Mirrors the CALCULATORS table in application/utils/calculators/__init__.py,
 * which owns which calculators exist; a slug missing here leaves that page
 * answering only on submit, never wrong. tests/js/calculators.test.mjs fails if
 * a slug in tests/fixtures/calculator_cases.json has no formula here.
 */

import { calculate as concrete } from "./_calc_concrete.js";
import { calculate as decking } from "./_calc_decking.js";
import { calculate as markup } from "./_calc_markup.js";
import { gravel, mulch, pavers, soil, turf } from "./_calc_materials.js";
import { calculate as roofPitch } from "./_calc_roof_pitch.js";
import { calculate as stair } from "./_calc_stair.js";

export const FORMULAS = {
    concrete,
    markup,
    "roof-pitch": roofPitch,
    stair,
    decking,
    soil,
    mulch,
    gravel,
    paver: pavers,
    turf,
};
